/** Full numbers with grouping (no M/K suffix). Widen YAxis if ticks clip. */
const groupedInteger = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 0,
  useGrouping: true,
});

export function formatYAxisTick(value: number): string {
  if (typeof value !== "number" || Number.isNaN(value)) return String(value);
  return groupedInteger.format(value);
}
